import { DEFAULT_LOCALE, LANG_TO_LOCALE } from './contants';
import type { TpLocale, TpMessages } from './types';

const translationCache = new Map<string, Promise<TpMessages>>();

export const getTranslationsByLang = (locale: string): Promise<TpMessages> => {
  if (!translationCache.has(locale)) {
    translationCache.set(
      locale,
      import(`./locales/${locale}.json`).then((messages) => ({
        ...messages,
      })),
    );
  }
  return translationCache.get(locale)!;
};

export const getMessages = async (lang: TpLocale): Promise<TpMessages> => {
  try {
    const targetLocale = LANG_TO_LOCALE[lang] || LANG_TO_LOCALE[DEFAULT_LOCALE];
    const defaultLocale = LANG_TO_LOCALE[DEFAULT_LOCALE];

    if (targetLocale === defaultLocale) {
      return await getTranslationsByLang(defaultLocale);
    }

    const [defaultMessages, targetMessages] = await Promise.all([
      getTranslationsByLang(defaultLocale),
      getTranslationsByLang(targetLocale),
    ]);

    return {
      ...defaultMessages,
      ...targetMessages,
    };
  } catch (error) {
    console.error('Error loading translations:', error);
    const defaultLocale = LANG_TO_LOCALE[DEFAULT_LOCALE];
    translationCache.delete(defaultLocale);
    return await getTranslationsByLang(defaultLocale);
  }
};
